module.exports = __webpack_public_path__ + "static/climate_sec2_obj2M@2x-40bc07f208334af30bbade913d5bd944.png";